import cn from 'classnames/bind';
import React__default from 'react';
import classes from './index.module.scss.js';
import classnames from 'classnames';

const cx = cn.bind(classes);
const Badge = ({ classes = [], children, themed = false, inverted = false, flavor = 'normal', }) => {
    return (React__default.createElement("span", { className: classnames(flavor === 'normal' ? 'overline' : 'caption', 'book', 'small', ...classes, cx('badge', {
            themed,
            inverted,
        })) }, children));
};
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=index.js.map
